import React, { useState } from 'react';
import { Button, Card } from 'antd';
import { EyeOutlined, SyncOutlined } from '@ant-design/icons';
import Typography from 'antd/es/typography/Typography';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCube } from '@fortawesome/free-solid-svg-icons';
import './FoodCard.css';

const FoodCard = ({ item, on3DClick }) => {
    const [flipped, setFlipped] = useState(false);

    return (
        <Card
            title={<span className='food-card-title'>{item.name}</span>}
            className='food-card'
            cover={
                <div className="image-flip-container">
                    <div className={`image-flip-inner ${flipped ? 'flipped' : ''}`}>
                        {/* Ön Yüz - Görsel */}
                        <div className="image-front">
                            <img
                                loading={'lazy'}
                                alt={item.name}
                                src={item.image}
                                className='food-card-image'
                            />
                            <SyncOutlined
                                className="flip-icon"
                                onClick={() => setFlipped(true)}
                            />
                        </div>

                        {/* Arka Yüz - Açıklama */}
                        {/* Arka Yüz - Açıklama + İkramlar */}
                        <div className="image-back">
                            <SyncOutlined
                                className="flip-icon"
                                onClick={() => setFlipped(false)}
                            />
                            <div className="image-back-content">
                                <h3 className="ikramlar-title">İkramlar</h3>
                                <ul className="ikramlar-list">
                                    <li>Çacık</li>
                                    <li>Mevsim Salata</li>
                                    <li>Mantar</li>
                                    <li>Fındık Lahmacun</li>
                                    <li>Ezme Salata</li>
                                    <li>Soğan Salatası</li>
                                    <li>Pişmiş Soğan</li>
                                    <li>Yeşillik</li>
                                    <li>Çiğ Köfte</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            }
        >
            <div className='food-card-footer'>
                <Typography className='food-card-price'>{item.price}</Typography>
                {item?.modalImage ? (
                    <Button
                        className='food-card-icon'
                        onClick={() => on3DClick(item)}
                    >
                        <FontAwesomeIcon icon={faCube} />
                        <Typography className='food-card-icon-text'>3D</Typography>
                    </Button>
                ) : (
                    <EyeOutlined
                        className='food-card-icon'
                        onClick={() => on3DClick(item)}
                    />
                )}
            </div>
        </Card>
    );
};

export default FoodCard;
